<template>
    <a :href=getUrl()
       class="link-mini-product"
       :style="tabColor()"
    >{{ product.name }} </a>
</template>

<script>
    import {mapGetters} from 'vuex'
    import * as types from '../store/types';
    import '../style/Product.scss';
    import {_CATEGORIES} from "../api";

    export default {
        name: 'Product',
        props: {
            product: Object
        },
        computed: {
            ...mapGetters({
                getHostname: types.GET_HOSTNAME,
            }),
        },
        data() {
            return {
                color: '',
            }
        },
        mounted() {
                this.getColor()
        },
        methods: {
            ...mapGetters({
                getUrlProduct: types.GET_URL_PRODUCT,
            }),
            getUrl() {
                return this.getUrlProduct()(this.product.id, this.getHostname);
            },
            getColor() {
                const {id_category_default} = this.product
                if (!id_category_default) {
                    return;
                }

                this.$http.get(
                    [_CATEGORIES, id_category_default].join('/'), {
                        params: {
                            output_format: 'JSON'
                        }
                    })
                    .then(response => {
                        return response.json();
                    })
                    .then(({category: {category_color}}) => {
                        this.color = category_color
                    });
            },
            tabColor() {
                return {
                        backgroundColor: this.color
                    };
            }

        },
        filters: {
            formatPrice(value) {
                return (Math.round(value * 100) / 100).toFixed(2) + ' €'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Product.vue